/**
 * Client-side context registry. Collects live page state entries that are
 * serialised into the contextDoc sent with every agent request.
 */

export interface ContextEntry {
  key: string;
  label: string;
  value: unknown;
  /** Field paths within value to scrub before sending */
  redact?: string[];
  /** Higher = kept when truncating to fit token budget */
  priority: number;
  registeredAt: number;
}

type SubscriberFn = (entries: ContextEntry[]) => void;

const store = new Map<string, ContextEntry>();
const subscribers = new Set<SubscriberFn>();

function notify(): void {
  const snapshot = Array.from(store.values());
  for (const fn of subscribers) {
    fn(snapshot);
  }
}

export function register(entry: ContextEntry): void {
  store.set(entry.key, entry);
  notify();
}

export function unregister(key: string): void {
  if (store.delete(key)) {
    notify();
  }
}

export function getAll(): ContextEntry[] {
  return Array.from(store.values());
}

export function subscribe(fn: SubscriberFn): () => void {
  subscribers.add(fn);
  return () => {
    subscribers.delete(fn);
  };
}
